<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
.border {
  padding: 10px;
  border: 1px solid grey;
  border-radius: 5px;
}
</style>

<template>
  <v-container fluid fill-height row>
    <v-layout justify-center align-start>
      <v-flex lg8 sm10 xs12>
        <v-stepper v-model="stepnow" vertical class="br-10">
          <v-card flat class="text-center transparent pa-2">
            <span class="title primary--text text--darken-2"><strong>{{ $t('trading_license_application') }}</strong></span>
          </v-card>

          <!-- application -->
          <v-stepper-step :complete="stepnow > 1" step="1" @click.native="stepnow = 1">
            {{ $t('applicant_information') }}
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-card class="mb-12" flat>
              <v-form ref="form1" v-model="valid" lazy-validation>
                <v-text-field clearable name="name" v-model="data.applicant.name" :label="$t('name', { field: $t('applicant') }) + ` *`" :rules="[rules.required]" required type="text"></v-text-field>
                <!-- <v-select readonly name="identity_type" v-model="data.applicant.identity_type" @input="data.applicant.identity_no = ''" :label="$t('identity_type')" :items="identity_type" :item-text="opt => $t(opt.value)" :item-value="opt => opt.value" :rules="[rules.required]"></v-select> -->
                <v-text-field clearable name="identity_no" :maxLength="data.applicant.identity_type === 'new_ic' ? '14' : undefined" @input="data.applicant.identity_no = $event" :value="data.applicant.identity_type === 'new_ic' ? icFormat(data.applicant.identity_no) : data.applicant.identity_no" :label="$t('identity_no', { field: $t('applicant') }) + ` *`" :rules="[rules.required, rules.nricLength, rules.dateOfBirth]" required type="text"></v-text-field>
                <v-row wrap align="center" justify="center" class="text-center">
                  <v-col sm="12" md="7" lg="7">
                    <v-text-field :disabled="verify.result" clearable name="phone" maxLength="11" v-model="data.applicant.phone" :label="$t('phone', { field: $t('applicant') }) + ` *`" :rules="[rules.required]" type="tel" required></v-text-field>
                  </v-col>
                  <v-col sm="12" md="5" lg="5">
                    <v-btn color="primary" rounded outlined :disabled="currentTime > 0 || data.applicant.phone.length < 10" @click="sendVerification" v-if="!verify.result">
                      {{ sent ? $t(`resend_verification`, { channel: 'SMS' }) : $t('send_verification', { channel: 'SMS' }) }} <span v-if="currentTime > 0">({{ currentTime }} s)</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row wrap align="center" justify="center" v-if="sent">
                  <v-col md="10" sm="12">
                    <v-text-field validate-on-blur :rules="[() => !!verify.input || 'This field is required']" v-model="verify.input" :label="$t('verification_code')" name="code" required type="text" :disabled="verify.result"></v-text-field>
                  </v-col>
                  <v-col md="2" sm="12">
                    <v-btn color="primary" rounded outlined :disabled="verify.input.length === 0 || verify.result" @click="verifyCode">
                      {{ $t("verify") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-text-field clearable name="email" v-model="data.applicant.email" :label="$t('email', { field: $t('applicant') }) + ` *`" :rules="[rules.required, rules.email]" type="email" required></v-text-field>
                <v-textarea clearable name="address" v-model="data.applicant.address" :label="$t('address', { field: $t('contact') }) + ` *`"  :rules="[rules.required]" type="text" required></v-textarea>
                <div class="text-right">
                  <v-btn :disabled="!verify.input" color="primary" @click="changeStep(`form1`, stepnow + 1)">{{ $t('continue') }}</v-btn>
                </div>
              </v-form>
            </v-card>
          </v-stepper-content>

          <!-- busineess info -->
          <v-stepper-step :complete="stepnow > 2" step="2" @click.native="stepnow > 1 ? stepnow = 2 : null">
            {{ $t('business_information') }}
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-card flat class="mb-12">
              <v-form ref="form2" v-model="valid" lazy-validation>
                <v-text-field clearable name="business_name" v-model="data.business.business_name" :label="$t('business_name') + ' *'" :rules="[rules.required]" required type="text"></v-text-field>
                <v-textarea clearable name="address" v-model="data.business.address" :label="`${$t('business_address')} *`" :rules="[rules.required]" required></v-textarea>
                <v-select name="state" readonly v-model="data.business.state" :label="$t('business_state') + ' *'" :rules="[rules.required]" :items="states" required></v-select>
                <v-text-field clearable maxLength="11" name="phone" v-model="data.business.phone" :label="$t('business_phone') + ' *'" :rules="[rules.required]" required type="tel"></v-text-field>
                <v-text-field clearable maxLength="11" name="fax" v-model="data.business.fax" :label="`${$t('business_fax')} (${$t('optional')})`" type="text"></v-text-field>
                <v-switch name="premise" class="mt-4" :label="$t('got_premise')" @change="onPremiseChanged" disabled v-model="data.business.premise"></v-switch>

                <div v-if="data.business.premise">
                  <v-text-field clearable name="assessment_no" v-model="data.business.assessment_no" :label="$t('assessment_no')" :rules="[rules.required]" required type="text"></v-text-field>
                  <h5>{{ $t("assessment_no_acquired_location") }}</h5>

                  <v-btn class="mt-2" color="primary" @click="onSearchPremise" :disabled="!data.business.assessment_no || data.business.assessment_no.length === 0">
                    <v-icon class="pr-3">fa-search fa-lg</v-icon>
                    {{ $t('search_assessment') }}
                  </v-btn>
                  <div v-if="data.business.title_no && data.business.title_no.length > 0">
                    <!-- get data from assessment info -->
                    <v-text-field readonly name="title_no" v-model="data.business.title_no" :label="$t('title_no') + ' (Tidak Boleh Diubah) *'" type="text"></v-text-field>
                    <v-text-field readonly name="payment_needed" v-model="data.business.payment_needed" :label="$t('payment_needed') + ' (RM) (Tidak Boleh Diubah) *'" type="text"></v-text-field>
                    <v-textarea readonly name="area" v-model="data.business.area" :label="$t('premise_address') + ' *'" type="text"></v-textarea>
                    <!-- <v-text-field disabled clearable name="no_of_trading_on_property" :value="data.business.no_of_trading_on_property" :label="$t('no_of_trading_on_property')" @input="patchBusiness({ business: { no_of_trading_on_property: $event } })" v-validate="'required'" :error-messages="errors.collect('no_of_trading_on_property')" :data-vv-as="$t('no_of_trading_on_property')" required type="text"></v-text-field>
                    <v-text-field disabled clearable name="use_code" :value="data.business.use_code" :label="$t('use_code')" @input="patchBusiness({ business: { use_code: $event } })" v-validate="'required'" :error-messages="errors.collect('use_code')" :data-vv-as="$t('use_code')" required type="text"></v-text-field> -->
                    <!-- <v-text-field disabled clearable name="installment" :value="data.business.installment" :label="$t('installment')" @input="patchBusiness({ business: { installment: $event } })" v-validate="'required'" :error-messages="errors.collect('installment')" :data-vv-as="$t('installment')" required type="text"></v-text-field> -->
                  </div>
                </div>

                <v-textarea clearable name="business_location" v-model="data.business.business_location" :label="$t('business_location') + ' *'" :rules="[rules.required]"></v-textarea>
                <v-text-field clearable name="bumiputera_share" v-model="data.business.bumiputera_share" :label="$t('bumiputera_share') + ' (%) *'" :rules="[rules.required, rules.percentage]" step="0.01" required type="number"></v-text-field>
                <v-select name="business_type" class="pt-4" :items="trcc" :item-text="opt => `${opt.code} - ${opt.name}`" :item-value="opt => opt._id" v-model="form.business_activity1" :label="$t('business_type')"></v-select>
                <v-select name="business_category" :items="trcs.filter(row => row.category_id === form.business_activity1)" :item-text="opt => `${opt.code} - ${opt.name}`" :item-value="opt => opt._id" @change="onCategoryChanged" v-model="form.business_activity2" :label="$t('business_category')"></v-select>
                <v-select
                  clearable
                  name="business_activity"
                  v-model="form.business_activity3"
                  :label="$t('business_activity')"
                  :items="trca.filter(row => row.premise === data.business.premise)"
                  :item-text="opt => `${opt.code} - ${opt.name}`"
                  :item-value="opt => opt"
                  >
                </v-select>
                <div class="row text-left mb-5">
                  <v-btn color="primary" @click="patchBusinessActivity(form.business_activity3)" :disabled="!form.business_activity3">
                    <v-icon class="pr-3">fa-plus fa-lg</v-icon>
                    {{ $t('add_business_activity') }}
                  </v-btn>
                </div>
                <table id="activity" class="mt-2" v-if="data.business.business_activity.length > 0">
                  <tr>
                    <th colSpan="2">{{ $t('business_activity') }}</th>
                  </tr>
                  <tr v-for="(act, index) in data.business.business_activity" :key="index">
                    <td>{{ `${act.code} - ${act.name}` }}</td>
                    <td width="20%" class="text-center" @click="removeBusinessActivity(index)">
                      <v-btn color="red" text>
                        <v-icon class="pr-3">fa-times fa-lg</v-icon>
                        {{ $t('remove') }}
                      </v-btn>
                    </td>
                  </tr>
                </table>
                <div class="text-center mt-5">
                  <span class="primary--text text--darken-2"><strong>{{ $t('supporting_documents') }}<br v-if="$vuetify.breakpoint.xsOnly" /> ({{ $t("for_verification_purpose") }})</strong></span>
                  <v-file-input :rules="[rules.required, rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_ic" type="file" v-model="photocopy_ic" :label="$t('photocopy_ic')" @change="handleFileUpload($event, 'photocopy_ic')" :clearable="false" @click:clear="photocopy_ic = data._attachments.photocopy_ic = null;" />
                  <v-file-input :rules="[rules.required, rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="sales_purchase_agreement" type="file" v-model="sales_purchase_agreement" :label="$t('sales_purchase_agreement')" @change="handleFileUpload($event, 'sales_purchase_agreement')" :clearable="false" @click:clear="sales_purchase_agreement = data._attachments.sales_purchase_agreement = null;" />
                  <v-file-input :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_submit_plan_receipt" type="file" v-model="photocopy_submit_plan_receipt" :label="$t('photocopy_submit_plan_receipt')" @change="handleFileUpload($event, 'photocopy_submit_plan_receipt')" :clearable="false" @click:clear="photocopy_submit_plan_receipt = data._attachments.photocopy_submit_plan_receipt = null;" />
                  <v-file-input :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_health_card" type="file" v-model="photocopy_health_card" :label="$t('photocopy_health_card')" @change="handleFileUpload($event, 'photocopy_health_card')" :clearable="false" @click:clear="photocopy_health_card = data._attachments.photocopy_health_card = null;" />
                  <v-file-input :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_food_handling_certificate" type="file" v-model="photocopy_food_handling_certificate" :label="$t('photocopy_food_handling_certificate')" @change="handleFileUpload($event, 'photocopy_food_handling_certificate')" :clearable="false" @click:clear="photocopy_food_handling_certificate = data._attachments.photocopy_food_handling_certificate = null;" />
                </div>


                <div class="text-right mt-5">
                  <v-btn outlined color="primary" @click="stepnow -= 1">{{ $t('previous') }}</v-btn>
                  <v-btn color="primary" :disabled="data.business.business_activity.length === 0" @click="changeStep(`form2`, stepnow + 1)">{{ $t('continue') }}</v-btn>
                </div>
              </v-form>
            </v-card>
          </v-stepper-content>

          <!-- council license -->
          <!-- <v-stepper-step :complete="stepnow > 3" step="3" @click.native="stepnow > 2 ? stepnow = 3 : null">
            {{ $t('council_license_information') }}
          </v-stepper-step> -->

          <!-- <v-stepper-content step="3">
            <v-card class="pa-5 grey lighten-2 mb-2" flat>
            {{ $t('no_council_license_needed') }}
            </v-card>
            <v-card class="mb-12" flat v-for="(item, index) in data.council_license" :key="index">
              <v-text-field clearable name="charge_per_unit" :value="item.charge_per_unit" :label="$t('charge_per_unit') + ' (RM)'" @input="patchCouncilLicense({ council_license: { charge_per_unit: $event}, index  })" v-validate="'required|min_value:0'" :error-messages="errors.collect('charge_per_unit')" :data-vv-as="$t('charge_per_unit')" required step="0.01" type="number"></v-text-field>
              <v-text-field clearable name="license_charge" :value="item.license_charge" :label="$t('license_charge') + ' (RM)'" @input="patchCouncilLicense({ council_license: { license_charge: $event }, index })" v-validate="'required|min_value:0'" :error-messages="errors.collect('license_charge')" :data-vv-as="$t('license_charge')" required step="0.01" type="number"></v-text-field>
              <v-text-field clearable name="other_charges" :value="item.other_charges" :label="$t('other_charges') + ' (RM)'" @input="patchCouncilLicense({ council_license: { other_charges: $event }, index })" v-validate="'required|min_value:0'" :error-messages="errors.collect('other_charges')" :data-vv-as="$t('other_charges')" required step="0.01" type="number"></v-text-field>
              <v-text-field clearable name="units" :value="item.units" :label="$t('units')" @input="patchCouncilLicense({ council_license: { units: $event }, index })" v-validate="'required|min_value:0'" :error-messages="errors.collect('units')" :data-vv-as="$t('units')" required step="1" type="number"></v-text-field>
            </v-card>

            <div class="text-right">
              <v-btn outlined color="primary" @click="stepnow = 2">{{ $t('previous') }}</v-btn>
              <v-btn color="primary" @click="stepnow = 4">{{ $t('continue') }}</v-btn>
            </div>
          </v-stepper-content> -->

          <!-- owner -->
          <v-stepper-step :complete="stepnow > 3" step="3" @click.native="stepnow > 2 ? stepnow = 3 : null">
            {{ $t('owner_information') }}
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card class="mb-12" flat>
              <v-form ref="form3" v-model="valid" lazy-validation>
                <v-select clearable name="ownership_type" v-model="data.ownership_type" :label="$t('ownership_type') + ' *'"  @change="onOwnershipChanged" :items="ownership_type" :item-text="opt => $t(opt.value)" :item-value="opt => opt.epbt2" :rules="[rules.required]"></v-select>
                <div v-if="!ownershipRequirement" class="text-h5 error--text text-center">{{ ownershipHint }} *</div>
                <!-- <v-list outlined shaped v-if="data.owners.length === 0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("no_owner_record_yet") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list> -->
                <v-expansion-panels v-if="data.owners.length > 0">
                  <v-expansion-panel
                    v-for="(owner, i) in data.owners"
                    :key="i"
                  >
                    <v-expansion-panel-header>
                      <v-icon class="pr-3">fa-user-circle</v-icon> <strong>{{ owner.name }} - {{ owner.identity_no }} ({{ ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type) ? $t(ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type).value) : '' }})</strong>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list outlined shaped>
                        <v-list-item two-line v-for="(key, j) in Object.keys(owner).filter(k => k !== 'name' && k !== 'type' && k !== 'identity_no' && k !== 'registered_company_name' && k !== 'register_no' && owner[k].replace(/[\s-]/g, '').length > 0).sort().reverse()" :key="j">
                          <v-list-item-content>
                            <v-list-item-title v-if="key === 'type'">{{ ownerTypes(data.ownership_type).find(t => t.epbt2 === owner[key]) ? $t(ownerTypes(data.ownership_type).find(t => t.epbt2 === owner[key]).value) : '' }}</v-list-item-title>
                            <v-list-item-title v-if="key === 'bumiputera_status'">{{ bumiputera_status.find(t => t.epbt2 === owner[key]) ? bumiputera_status.find(t => t.epbt2 === owner[key]).value : '' }}</v-list-item-title>
                            <v-list-item-title v-if="key === 'company_type'">{{ company_type.find(t => t.epbt2 === owner[key]) ? company_type.find(t => t.epbt2 === owner[key]).value : '' }}</v-list-item-title>
                            <v-list-item-title v-if="key === 'identity_type'">{{ identity_type.find(t => t.value === owner[key]) ? $t(identity_type.find(t => t.value === owner[key]).value) : '' }}</v-list-item-title>
                            <v-list-item-title v-if="key === 'gender'">{{ gender.find(t => t.epbt2 === owner[key]) ? $t(gender.find(t => t.epbt2 === owner[key]).value) : '' }}</v-list-item-title>
                            <v-list-item-title v-if="key === 'citizenship'">{{ citizenship.find(t => t.epbt2 === owner[key]) ? citizenship.find(t => t.epbt2 === owner[key]).value : '' }}</v-list-item-title>
                            <v-list-item-title v-if="key === 'ownership_type'">{{ ownership_type.find(t => t.epbt2 === owner[key]) ? ownership_type.find(t => t.epbt2 === owner[key]).value : '' }}</v-list-item-title>
                            <v-list-item-title v-if="key === 'religion'">{{ religion.find(t => t.epbt2 === owner[key]) ? religion.find(t => t.epbt2 === owner[key]).value : '' }}</v-list-item-title>
                            <v-list-item-title v-if="!special_properties.includes(key)">{{ owner[key] }}</v-list-item-title>
                            <v-list-item-subtitle>{{ $t(key) }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action v-if="j === 0">
                            <v-btn icon @click="removeOwner(i)">
                              <v-icon color="error">fa-trash</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-list outlined shaped v-if="ownershipRequired.length > 0">
                  <v-list-item v-for="(item, i) in ownershipRequired" :key="i">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t(`required_ownership`, { field: $t(item) }) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <br />
                <v-divider />
                <br />
                <v-row no-gutters align="center" class="text-center">
                  <v-col cols="12">
                    <v-switch name="same_as_applicant" :label="$t('same_as_applicant')" @change="onSameAsApplicantChanged" v-model="same_as_applicant"></v-switch>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select clearable name="type" v-model="owner.type" :label="$t('type') + ' *'" :items="ownerTypes(data.ownership_type)" :item-text="opt => $t(opt.value)" :item-value="opt => opt.epbt2" :rules="[rules.required]"></v-select>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="owner_name" v-model="owner.name" :label="`${$t('name', { field: ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type) ? $t(ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type).value) : '' })} *`" :rules="[rules.required]" required type="text"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="identity_no" :label="$t('identity_no', { field: ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type) ? $t(ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type).value) : '' }) + ' *'" :maxLength="owner.identity_type === 'new_ic' ? '14' : undefined" @input="onIdentityInput(`owner`, $event)" :value="owner.identity_type === 'new_ic' ? icFormat(owner.identity_no) : owner.identity_no" :rules="[rules.required, rules.nricLength, rules.dateOfBirth]" required type="text"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field readonly name="date_of_birth" v-model="owner.date_of_birth" :label="$t('date_of_birth') + ' *'" :rules="[rules.required]" placeholder="DD/MM/YYYY" required type="date"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="work_pass" v-model="owner.work_pass" :label="`${$t('work_pass')} (${$t('optional')})`" required type="text"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="expired_date_of_pass" v-model="owner.expired_date_of_pass" :label="`${$t('expired_date_of_pass')} (${$t('optional')})`" placeholder="DD/MM/YYYY" required type="date"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select clearable name="citizenship" v-model="owner.citizenship" :label="$t('citizenship') + ' *'" :rules="[rules.required]" :items="citizenship" :item-text="opt => opt.value" :item-value="opt => opt.epbt2"></v-select>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select clearable name="religion" v-model="owner.religion" :label="$t('religion') + ' *'" :rules="[rules.required]" :items="religion" :item-text="opt => opt.value" :item-value="opt => opt.epbt2"></v-select>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select clearable name="race" v-model="owner.race" :label="$t('race') + ' *'" :rules="[rules.required]" :items="race"></v-select>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select clearable name="bumiputera_status" v-model="owner.bumiputera_status" :label="$t('bumiputera_status') + ' *'" :rules="[rules.required]" :items="bumiputera_status" :item-text="opt => opt.value" :item-value="opt => opt.epbt2"></v-select>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-textarea clearable name="residential_address" v-model="owner.residential_address" :label="$t('residential_address') + ' *'" :rules="[rules.required]" required type="text"></v-textarea>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-textarea clearable name="mailing_address" v-model="owner.mailing_address" :label="$t('mailing_address') + ' *'" :rules="[rules.required]" required type="text"></v-textarea>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable maxLength="11" name="mobile_tel" v-model="owner.mobile_tel" :label="$t('mobile_tel') + ' *'" :rules="[rules.required]" required type="tel"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field maxLength="11" clearable name="office_tel" v-model="owner.office_tel" :label="`${$t('office_tel')} (${$t('optional')})`" required type="tel"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field maxLength="11" clearable name="residential_tel" v-model="owner.residential_tel" :label="`${$t('residential_tel')} (${$t('optional')})`" required type="tel"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-btn color="primary" @click="addOwner">
                      <v-icon class="pr-3">fa-plus</v-icon> {{ $t('add_owner', { field: ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type) ? $t(ownerTypes(data.ownership_type).find(t => t.epbt2 === owner.type).value) : '' }) }}
                    </v-btn>
                  </v-col>
                  <!-- <v-select readonly name="identity_type" v-model="owner.identity_type" @input="owner.identity_no = ''" :label="$t('identity_type')" :rules="[rules.required]" :items="identity_type" :item-text="opt => $t(opt.value)" :item-value="opt => opt.value"></v-select> -->

                  <!-- <v-select readonly name="gender" v-model="owner.gender" :label="$t('gender')" :rules="[rules.required]" :items="gender" :item-text="opt => $t(opt.value).toUpperCase()" :item-value="opt => opt.value"></v-select> -->
                  <!-- <v-text-field clearable name="nationality" v-model="owner.nationality" :label="$t('nationality')" :rules="[rules.required]" required type="text"></v-text-field> -->
                </v-row>
                <br /><br /><br />
                <div class="text-right">
                  <v-btn outlined color="primary" @click="stepnow -= 1">{{ $t('previous') }}</v-btn>
                  <v-btn :disabled="!ownershipRequirement" color="primary" @click="changeStep(`form3`, stepnow + 1)">{{ $t('continue') }}</v-btn>
                </div>
              </v-form>
            </v-card>
          </v-stepper-content>

          <!-- manager -->
          <v-stepper-step :complete="stepnow > 4" step="4" @click.native="stepnow > 3 ? stepnow = 4 : null">
            {{ $t('company_information') }}
          </v-stepper-step>

          <v-stepper-content step="4">
            <v-card class="pa-5 grey lighten-2 mb-2" flat v-if="data.ownership_type && data.ownership_type === 'sole_proprietor' || data.ownership_type === 'partnership' || data.ownership_type === '1' || data.ownership_type === '2'">
              {{ $t('click_submit_to_complete_registration') }}
            </v-card>
            <v-card class="mb-12" flat v-else>
              <v-form ref="form4" v-model="valid" lazy-validation>
                <v-row no-gutters v-if="data.ownership_type === 'private_limited_company' || data.ownership_type === 'public_limited_company' || data.ownership_type === 'corporation_company' || data.ownership_type === '3' || data.ownership_type === '4' || data.ownership_type === '5'">
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select clearable name="company_type" v-model="data.company_organization.company_type" :label="$t('company_type') + ' *'" :rules="[rules.required]" :items="company_type.filter(row => row.type === 'company')" :item-text="opt => opt.value" :item-value="opt => opt.epbt2"></v-select>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="registered_company_name" v-model="data.company_organization.name" :rules="[rules.required]" :label="$t('registered_company_name') + ' *'" required type="text"></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="data.ownership_type === 'organization_or_cooperation' || data.ownership_type === '6'">
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select clearable name="company_type" v-model="data.company_organization.company_type" :rules="[rules.required]" :label="$t('company_type') + ' *'" :items="company_type.filter(row => row.type === 'organization_or_cooperation')" :item-text="opt => opt.value" :item-value="opt => opt.value"></v-select>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="name_of_organization_cooperation" :rules="[rules.required]" v-model="data.company_organization.name" :label="$t('name_of_organization_cooperation') + ' *'" required type="text"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="organization_cooperation_field" :rules="[rules.required]" v-model="data.company_organization.organization_cooperation_field" :label="$t('organization_cooperation_field') + ' *'" @input="patchOwner({ owner: { organization_cooperation_field: $event } })" required type="text"></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="data.ownership_type === 'government' || data.ownership_type === '9'">
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="name_of_glc" v-model="data.company_organization.name" :label="$t('name_of_glc') + ' *'" :rules="[rules.required]" required type="text"></v-text-field>
                  </v-col>
                </v-row>

                <v-row no-gutters v-if="data.ownership_type && data.ownership_type !== 'sole_proprietor' && data.ownership_type !== 'partnership' && data.ownership_type !== '1' && data.ownership_type !== '2'">
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="register_no" v-model="data.company_organization.register_no" :label="$t('register_no') + ' *'" :rules="[rules.required]" required type="text"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea clearable name="office_address" v-model="data.company_organization.office_address" :label="$t('office_address') + ' *'" :rules="[rules.required]" required type="text"></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea clearable name="mailing_address" v-model="data.company_organization.mailing_address" :label="$t('mailing_address') + ' *'" :rules="[rules.required]" required type="text"></v-textarea>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field maxLength="11" clearable name="phone" v-model="data.company_organization.phone" :label="$t('phone', { field: $t('company_organization') }) + ' *'" :rules="[rules.required]" required type="tel"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field maxLength="11" clearable name="fax" v-model="data.company_organization.fax" :label="`${$t('fax', { field: $t('company_organization') })} (${$t('optional')})`" type="tel"></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="email" v-model="data.company_organization.email" :label="$t('email', { field: $t('company_organization') }) + ' *'" :rules="[rules.required, rules.email]" type="email" required></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-text-field clearable name="homepage" v-model="data.company_organization.homepage" :label="`${$t('homepage')} (${$t('optional')})`" required type="text"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
            <br /><br />
            <div class="text-right">
              <v-btn outlined color="primary" @click="stepnow -= 1">{{ $t('previous') }}</v-btn>
              <!-- <v-btn color="primary" @click="changeStep(`form4`, stepnow + 1)">{{ $t('continue') }}</v-btn> -->
              <v-btn color="primary" @click="submitForm">{{ $t('submit') }}</v-btn>
            </div>
          </v-stepper-content>

          <!-- <v-stepper-step :complete="stepnow > 5" step="5" @click.native="stepnow > 4 ? stepnow = 5 : null">
            {{ $t('upload_attachments') }}
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-card class="mb-12" flat>
              <trading-required-documents />
              <additional-docs />
              <br />
              <v-form ref="form5" v-model="valid" lazy-validation>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-file-input :rules="[rules.required]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="photocopy_entity" type="file" v-model="photocopy_entity" :label="photocopyEntityLabel" @change="handleFileUpload($event, 'photocopy_entity')" :clearable="false" @click:clear="photocopy_entity = data._attachments.photocopy_entity = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :rules="[rules.required]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="passport_photo" type="file" v-model="passport_photo" :label="$t('passport_photo')" @change="handleFileUpload($event, 'passport_photo')" :clearable="false" @click:clear="passport_photo = data._attachments.passport_photo = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="photocopy_oc_or_permit_building" type="file" v-model="photocopy_oc_or_permit_building" :label="$t('photocopy_oc_or_permit_building')" @change="handleFileUpload($event, 'photocopy_oc_or_permit_building')" :clearable="false" @click:clear="photocopy_oc_or_permit_building = data._attachments.photocopy_oc_or_permit_building = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="photocopy_approval_docs" type="file" v-model="photocopy_approval_docs" :label="$t('photocopy_approval_docs')" @change="handleFileUpload($event, 'photocopy_approval_docs')" :clearable="false" @click:clear="photocopy_approval_docs = data._attachments.photocopy_approval_docs = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="photocopy_receipt_premise" type="file" v-model="photocopy_receipt_premise" :label="$t('photocopy_receipt_premise')" @change="handleFileUpload($event, 'photocopy_receipt_premise')" :clearable="false" @click:clear="photocopy_receipt_premise = data._attachments.photocopy_receipt_premise = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="photocopy_approval_amendment_building" type="file" v-model="photocopy_approval_amendment_building" :label="$t('photocopy_approval_amendment_building')" @change="handleFileUpload($event, 'photocopy_approval_amendment_building')" :clearable="false" @click:clear="photocopy_approval_amendment_building = data._attachments.photocopy_approval_amendment_building = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="additional_document1" type="file" v-model="additional_document1" :label="$t('additional_document') + ' 1'" @change="handleFileUpload($event, 'additional_document1')" :clearable="false" @click:clear="additional_document1 = data._attachments.additional_document1 = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="additional_document2" type="file" v-model="additional_document2" :label="$t('additional_document')  + ' 2'" @change="handleFileUpload($event, 'additional_document2')" :clearable="false" @click:clear="additional_document2 = data._attachments.additional_document2 = null;" />
                  </v-col>
                  <v-col cols="12">
                    <v-file-input :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="additional_document3" type="file" v-model="additional_document3" :label="$t('additional_document') + ' 3'" @change="handleFileUpload($event, 'additional_document3')" :clearable="false" @click:clear="additional_document3 = data._attachments.additional_document3 = null;" />
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
            <br /><br />
            <div class="text-right">
              <v-btn outlined color="primary" @click="stepnow = 4">{{ $t('previous') }}</v-btn>
              <v-btn :disabled="Object.values(data._attachments).filter(Boolean).length < 2" color="primary" @click="submitForm">{{ $t('submit') }}</v-btn>
            </div>
          </v-stepper-content> -->
        </v-stepper>
      </v-flex>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-layout>
    <canvas id="imageCanvas" class="d-none" />
  </v-container>
</template>

<script>
/* eslint-disable camelcase */
import _ from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import i18n from '../../i18n'
import AdditionalDocs from './additional_document'
import TradingRequiredDocuments from './trading_required_documents'

const DEFAULT_FORM_DATA = {
  type: 'trading_license',
  status: 'submitted',
  timestamp: new Date().toISOString(),
  _attachments: {
    photocopy_ic: null,
    sales_purchase_agreement: null,
    photocopy_submit_plan_receipt: null,
    photocopy_health_card: null,
    photocopy_food_handling_certificate: null,
    photocopy_entity: null,
    passport_photo: null,
    photocopy_oc_or_permit_building: null,
    photocopy_approval_docs: null,
    photocopy_receipt_premise: null,
    photocopy_approval_amendment_building: null,
    additional_document1: null,
    additional_document2: null,
    additional_document3: null
  },
  applicant: {
    name: '',
    identity_type: 'new_ic',
    identity_no: '',
    phone: '',
    email: '',
    address: ''
  },
  business: {
    business_name: '',
    address: '',
    phone: '',
    fax: '',
    business_location: '',
    business_activity: [],
    bumiputera_share: '',
    premise: true,
    assessment_no: '',
    state: 'SABAH'
  },
  council_license: [],
  owners: [],
  ownership_type: '1',
  company_organization: {
    office_address: '',
    mailing_address: '',
    company_type: '',
    register_no: '',
    phone: '',
    fax: '',
    email: '',
    homepage: '',
    name: '',
    organization_cooperation_field: ''
  }
}
const DEFAULT_OWNER_FORM = {
  bumiputera_status: '',
  residential_address: '',
  residential_tel: '',
  mobile_tel: '',
  office_tel: '',
  mailing_address: '',
  citizenship: '1',
  expired_date_of_pass: '',
  religion: '',
  race: '',
  name: '',
  identity_type: 'new_ic',
  work_pass: '',
  identity_no: '',
  date_of_birth: '',
  nationality: 'MALAYSIAN',
  state: 'SABAH',
  type: '1'
}

const calculateAspectRatioFit = (
  srcWidth,
  srcHeight,
  maxWidth,
  maxHeight
) => {
  var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
  var rtnWidth = srcWidth * ratio
  var rtnHeight = srcHeight * ratio

  return { width: rtnWidth, height: rtnHeight }
}

const downscaleImage = file => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()

    fileReader.onload = event => {
      const arrayBuffer = event.target.result
      const blob = new Blob([arrayBuffer], { type: 'image/jpeg' })
      const objectUrl = URL.createObjectURL(blob)
      let canvas = document.getElementById('imageCanvas')
      let context = canvas.getContext('2d')
      let image = new Image()

      image.src = objectUrl
      image.onload = () => {
        const { width, height } = calculateAspectRatioFit(
          image.width,
          image.height,
          2048,
          1152
        )

        canvas.width = width
        canvas.height = height
        context.drawImage(image, 0, 0, width, height)
        const data = canvas.toDataURL('image/jpeg', 0.95)
        resolve(data)
      }
    }

    fileReader.onerror = () => {
      fileReader.abort()
      reject(fileReader.error)
    }

    fileReader.readAsArrayBuffer(file)
  })
}

const handleFile = file => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = event => {
      const data = event.target.result
      resolve(data)
    }
    fileReader.onerror = () => {
      fileReader.abort()
      reject(fileReader.error)
    }
    fileReader.readAsDataURL(file)
  })
}

export default {
  beforeMount: async function () {
    this.loading = true
    await this.fetchActivities()
    window.addEventListener('beforeunload', this.preventNav)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventNav)
    })
    this.loading = false
  },
  components: {
    AdditionalDocs,
    TradingRequiredDocuments
  },
  computed: {
    ...mapGetters({
      hasName: 'auth/hasName',
      hasSession: 'auth/hasSession'
    }),
    ...mapState({
      trcc: (state) => state.tradingForm.trcc,
      trcs: (state) => state.tradingForm.trcs,
      trca: (state) => state.tradingForm.trca
    }),
    photocopyEntityLabel () {
      if (this.data.ownership_type === '3' || this.data.ownership_type === '4' || this.data.ownership_type === '5') {
        return this.$t(`photocopy_company_registration`)
      }
      if (this.data.ownership_type === '6') {
        return this.$t(`photocopy_registraion_cert`)
      }
      return this.$t(`photocopy_ic`)
    },
    ownershipRequirement () {
      if (this.data.ownership_type === '1') {
        return this.data.owners.filter(o => o.type === '1').length > 0
      }
      if (this.data.ownership_type === '2') {
        return this.data.owners.filter(o => o.type === '1').length > 0 && this.data.owners.filter(o => o.type === '2').length > 0
      }
      return this.data.owners.filter(o => o.type === '2').length > 0
    },
    ownershipHint () {
      if (this.data.ownership_type === '1') return i18n.t(`required_one_pemilik`)
      if (this.data.ownership_type === '2') return i18n.t(`required_one_pemilik_one_partner`)
      return i18n.t(`required_one_manager`)
    },
    ownershipRequired () {
      let list = []
      if (this.data.ownership_type === '1') {
        const pemilik = this.data.owners.filter(o => o.type === '1')
        if (pemilik.length === 0) list.push('owner')
        return list
      }
      if (this.data.ownership_type === '2') {
        const pemilik = this.data.owners.filter(o => o.type === '1')
        if (pemilik.length === 0) list.push('owner')
        const partners = this.data.owners.filter(o => o.type === '2')
        if (partners.length === 0) list.push('partnerships')
        return list
      }
      const manager = this.data.owners.filter(o => o.type === '2')
      if (manager.length === 0) list.push('manager')
      return list
    },
    rules () {
      return {
        dateOfBirth: value => (value && value.length > 6 ? (((parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) < 32 && parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) > 0) && (parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) < 13 && parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) > 0)) || i18n.t('invalidDateOfBirth')) : true),
        required: value => !!value || i18n.t('requiredField'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || i18n.t('invalidEmailFormat')
        },
        percentage: value => (Number(value) <= 100 && Number(value) >= 0) || i18n.t('invalidPercentage'),
        nricLength: value => (value ? (value.replace(/[\s-]/g, '').length === 12 || i18n.t('invalidNRICFormat')) : true),
        fileSizeLimit: value => !value || value.size < 1572864 || 'File size should be less than 1.5 MB!'
      }
    }
  },
  created: async function () {
    await this.$store.dispatch('auth/session')
  },
  data () {
    return {
      data: _.cloneDeep(DEFAULT_FORM_DATA),
      date: new Date().toISOString().substr(0, 10),
      stepnow: 1,
      same_as_applicant: false,
      valid: false,
      loading: false,
      currentTime: 0,
      verify: {
        code: null,
        input: '',
        result: false
      },
      photocopy_ic: null,
      sales_purchase_agreement: null,
      photocopy_submit_plan_receipt: null,
      photocopy_health_card: null,
      photocopy_food_handling_certificate: null,
      photocopy_entity: null,
      passport_photo: null,
      photocopy_oc_or_permit_building: null,
      photocopy_approval_docs: null,
      photocopy_receipt_premise: null,
      photocopy_approval_amendment_building: null,
      additional_document1: null,
      additional_document2: null,
      additional_document3: null,
      sent: false,
      timer: null,
      owner: _.cloneDeep(DEFAULT_OWNER_FORM),
      form: {
        business_activity1: '',
        business_activity2: '',
        business_activity3: ''
      },
      company_type: [
        { value: 'The Registrar of Cos', type: 'company', epbt2: '1' },
        { value: 'Wholly Owned By', type: 'company', epbt2: '2' }
      ],
      identity_type: [
        { value: 'new_ic' },
        { value: 'old_ic' },
        { value: 'passport_no' }
      ],
      gender: [
        { value: 'male', epbt2: 'L' },
        { value: 'female', epbt2: 'P' }
      ],
      citizenship: [
        { value: 'MALAYSIAN - SABAH', epbt2: '1' },
        { value: 'MALAYSIAN - SARAWAK / SEMENANJUNG MALAYSIA', epbt2: '2' },
        { value: 'PEMASTAUTIN / PEMEGANG PERMIT TINGGAL TETAP', epbt2: '3' },
        { value: 'OTHERS', epbt2: '3' }
      ],
      ownership_type: [
        { value: 'sole_proprietor', epbt2: '1' },
        { value: 'partnership', epbt2: '2' },
        { value: 'private_limited_company', epbt2: '3' },
        { value: 'public_limited_company', epbt2: '4' },
        { value: 'corporation_company', epbt2: '5' },
        { value: 'organization_or_cooperation', epbt2: '6' },
        { value: 'government', epbt2: '9' }
      ],
      bumiputera_status: [{ value: 'Bumiputera', epbt2: '1' }, { value: 'Non-Bumiputera', epbt2: '2' }],
      religion: [
        { value: 'ISLAM', epbt2: '1' },
        { value: 'CHRISTIAN', epbt2: '2' },
        { value: 'BUDDHIST', epbt2: '3' },
        { value: 'OTHERS', epbt2: '4' }
      ],
      race: [
        'ARABIAN',
        'BAJAU',
        'BANJAR',
        'BATAK',
        'BISAYA',
        'BOLONGAN',
        'BRUNEI',
        'BUGIS',
        'BUTON',
        'CHINESE',
        'DUSUN',
        'EAU',
        'IBAN',
        'INDIAN',
        'JAWA',
        'KADAZAN',
        'MELAYU',
        'MINANG',
        'MURUT',
        'PAKISTAN',
        'SAB',
        'SIN',
        'SULUK',
        'TATOR',
        'TIDUNG',
        'TIMORESE',
        'TORAJA',
        'VISAYA',
        'OTHERS'
      ],
      states: [
        'WILAYAH PERSEKUTUAN KUALA LUMPUR',
        'WILAYAH PERSEKUTUAN LABUAN',
        'WILAYAH PERSEKUTUAN PUTRAJAYA',
        'JOHOR',
        'KEDAH',
        'KELANTAN',
        'MELAKA',
        'NEGERI SEMBILAN',
        'PAHANG',
        'PERAK',
        'PERLIS',
        'PULAU PINANG',
        'SABAH',
        'SARAWAK',
        'SELANGOR',
        'TERENGGANU'
      ],
      special_properties: ['bumiputera_status', 'company_type', 'identity_type', 'gender', 'citizenship', 'ownership_type', 'religion', 'type']
    }
  },
  methods: {
    ...mapActions({
      onBusinessCategoryChanged: 'tradingForm/onBusinessCategoryChanged',
      searchData: 'tradingForm/searchData',
      fetchActivities: 'tradingForm/fetchActivities',
      submitData: 'tradingForm/submitData',
      sendSMS: 'tradingForm/sendSMS'
    }),
    ...mapMutations({
      resetData: 'tradingForm/resetData',
      resetManager: 'tradingForm/resetManager',
      resetOwner: 'tradingForm/resetOwner',
      setData: 'tradingForm/setData',
      patchBusiness: 'tradingForm/patchBusiness',
      patchCouncilLicense: 'tradingForm/patchCouncilLicense',
      patchOwner: 'tradingForm/patchOwner',
      patchManager: 'tradingForm/patchManager'
    }),
    countdown () {
      if (this.currentTime > 0) {
        this.currentTime -= 1
        setTimeout(this.countdown, 1000)
      } else {
        this.currentTime = 0
      }
    },
    async handleFileSelect (files) {
      let data = null
      let isMultiple = Array.isArray(files)

      if (typeof files === 'undefined') {
        return
      }

      try {
        if (isMultiple) {
          data = []
          for (const file of files) {
            if (file instanceof File) {
              if (file.name.split('.').pop() === 'pdf') {
                data.push(await handleFile(file))
              } else {
                data.push(await downscaleImage(file))
              }
            }
          }
        } else {
          if (files instanceof File) {
            if (files.name.split('.').pop() === 'pdf') {
              data = await handleFile(files)
            } else {
              data = await downscaleImage(files)
            }
          }
        }

        return data
      } catch (error) {
        console.log(error)
      }
    },
    async handleFileUpload (file, field) {
      const result = await this.handleFileSelect(file)
      if (!result) return
      this.data._attachments[field] = {
        content_type: result.split(';')[0].replace('data:', ''),
        data: result.split(',')[result.split(',').length - 1]
      }
    },
    sendVerification: _.throttle(async function () {
      this.currentTime = 180
      this.verify.code = Math.floor(100000 + Math.random() * 900000).toString()
      setTimeout(this.countdown, 1)
      this.sent = true
      await this.sendSMS({
        contact: this.data.applicant.phone.replace(/\s/g, ''),
        message: `Your verification code is ${this.verify.code} for applying MPT trading license. Expires in 3 mins. Date: ${new Date().toLocaleString()}`,
        notify: true
      })
    }, 1000),
    verifyCode () {
      if (this.verify.code === this.verify.input) {
        this.verify.result = true
        this.$store.dispatch('snackbar/setSnackBar', {color: 'success', message: this.$t('verify_successful'), visible: true})
        return
      }
      this.verify.result = false
      this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: this.$t('invalid_code'), visible: true})
    },
    async onCategoryChanged ($event) {
      this.loading = true
      await this.onBusinessCategoryChanged($event)
      this.loading = false
    },
    addOwner () {
      const valid = this.$refs.form3.validate()
      if (!valid) return
      for (let key of Object.keys(this.owner)) {
        if (key === 'email' || key === 'ownership_type' || key === 'identity_type') {
          this.owner[key] = this.owner[key].trim()
          continue
        }
        this.owner[key] = this.owner[key].length > 0 ? this.owner[key].trim().toUpperCase() : '-'
      }
      this.data.owners.push(this.owner)
      this.owner = Object.assign({}, DEFAULT_OWNER_FORM)
      this.same_as_applicant = false
      this.$refs.form3.resetValidation()
    },
    removeOwner (index) {
      if (index < 0) return
      this.data.owners.splice(index, 1)
    },
    onPremiseChanged (value) {
      if (!value) {
        delete this.data.business.title_no
        delete this.data.business.payment_needed
        delete this.data.business.area
        delete this.data.business.use_code
        delete this.data.business.no_of_trading_on_property
        delete this.data.business.installment
        delete this.data.business.bumiputera_share
      }
    },
    onSameAsApplicantChanged (value) {
      if (value) {
        this.owner.name = this.data.applicant.name
        this.onIdentityInput('owner', this.data.applicant.identity_no)
        this.owner.mobile_tel = this.data.applicant.phone
        this.owner.residential_address = this.data.applicant.address
        this.owner.mailing_address = this.data.applicant.address
      } else {
        this.owner.name = ''
        this.owner.identity_no = ''
        this.owner.mobile_tel = ''
        this.owner.mailing_address = ''
      }
    },
    ownerTypes (type) {
      if (type === '1' || type === '2' || type === 'sole_proprietor' || type === 'partnership') {
        return [
          { value: 'owner', epbt2: '1' },
          { value: 'partnerships', epbt2: '2' },
          { value: 'manager', epbt2: '3' }
        ]
      }
      return [
        { value: 'director', epbt2: '1' },
        { value: 'manager', epbt2: '2' },
        { value: 'company_secretary', epbt2: '3' },
        { value: 'secretary', epbt2: '4' }
      ]
    },
    async onSearchPremise () {
      this.loading = true
      const assessment = await this.searchData(this.data.business.assessment_no)
      this.data.business = _.merge({}, this.data.business, {
        assessment_account_id: assessment._id,
        title_no: assessment.current_title,
        payment_needed: assessment.arrears_only / 100,
        area: assessment.locality,
        use_code: '-',
        no_of_trading_on_property: '-',
        installment: false,
        business_location: assessment.locality
      })
      this.loading = false
    },
    preventNav (event) {
      event.preventDefault()
      event.returnValue = ''
    },
    patchBusinessActivity: function (business_activity) {
      if (this.data.business.business_activity.filter(row => row._id === business_activity._id).length === 0) {
        this.data.business.business_activity.push(business_activity)
      }
    },
    onOwnershipChanged () {
      this.owner = _.merge({}, DEFAULT_OWNER_FORM)
      this.same_as_applicant = false
      this.data.owners = []
    },
    onIdentityInput (type, $event) {
      this.owner.identity_no = $event
      if (this.owner.identity_no.length > 5) {
        const today = new Date()
        const thisYear = today.getFullYear().toString().substr(2)
        this.owner.date_of_birth = parseInt(thisYear) > parseInt(this.owner.identity_no.substr(0, 2)) ? `20${this.owner.identity_no.substr(0, 2)}-${this.owner.identity_no.substr(2, 2)}-${this.owner.identity_no.substr(4, 2)}` : `19${this.owner.identity_no.substr(0, 2)}-${this.owner.identity_no.substr(2, 2)}-${this.owner.identity_no.substr(4, 2)}`
      }
      if (this.owner.identity_no.replace(/[\s-]/g, '').length === 12) {
        const lastDigit = parseInt(this.owner.identity_no.substr(this.owner.identity_no.length - 1))
        this.owner.gender = lastDigit % 2 === 0 ? 'P' : 'L'
      }
    },
    removeBusinessActivity: function (index) {
      if (index < 0) return
      this.data.business.business_activity.splice(index, 1)
    },
    changeStep (currentForm, nextStep) {
      if (currentForm === 'form3' || !this.$refs[currentForm]) {
        this.stepnow = nextStep
        return
      }
      const valid = this.$refs[currentForm].validate()
      if (!valid) return
      if (currentForm === 'form1') {
        this.data.applicant.name = this.data.applicant.name.trim().toUpperCase()
        this.data.applicant.identity_no = this.data.applicant.identity_no.trim().toUpperCase()
        this.data.applicant.phone = this.data.applicant.phone.trim().toUpperCase()
        this.data.applicant.email = this.data.applicant.email.trim()
        this.data.applicant.address = this.data.applicant.address.trim().toUpperCase()
      }
      if (currentForm === 'form2') {
        if (this.data.business.premise && (!this.data.business.title_no || this.data.business.title_no.length === 0)) {
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'red',
            message: i18n.t('premise_required'),
            visible: true
          })
          return
        }
        this.data.business.business_name = this.data.business.business_name.trim().toUpperCase()
        this.data.business.address = this.data.business.address.trim().toUpperCase()
        this.data.business.phone = this.data.business.phone.trim().toUpperCase()
        this.data.business.fax = this.data.business.fax.length > 0 ? this.data.business.fax.trim().toUpperCase() : '-'
        this.data.business.business_location = this.data.business.business_location.trim().toUpperCase()
      }
      this.stepnow = nextStep
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    icFormat (value) {
      if (!value) return ''
      const format = value.replace(/[-\s]/g, '')
      if (format.length > 8) return `${format.substr(0, 6)}-${format.substr(6, 2)}-${format.substr(8)}`
      if (format.length > 6) return `${format.substr(0, 6)}-${format.substr(6, 2)}`
      return format
    },
    submitForm: async function ($event) {
      if (this.data.ownership_type && this.data.ownership_type !== 'sole_proprietor' && this.data.ownership_type !== 'partnership' && this.data.ownership_type !== '1' && this.data.ownership_type !== '2') {
        const valid = this.$refs.form4.validate()
        if (!valid || this.data.business.business_activity.length < 1) {
          if (this.data.business.business_activity.length < 1) {
            this.$store.dispatch('snackbar/setSnackBar', {
              color: 'red',
              message: i18n.t('please_add_business_activity'),
              visible: true
            })
            return
          }
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'red',
            message: i18n.t('incomplete_form'),
            visible: true
          })
          return
        }
      }
      for (let key of Object.keys(this.data.company_organization)) {
        if (key === 'email' || key === 'homepage') {
          this.data.company_organization[key] = this.data.company_organization[key].length > 0 ? this.data.company_organization[key].trim() : '-'
          continue
        }
        this.data.company_organization[key] = this.data.company_organization[key].length > 0 ? this.data.company_organization[key].trim().toUpperCase() : '-'
      }
      this.loading = true
      try {
        const response = await this.submitData(this.data)
        if (response && response.id) {
          this.$router.push(`/trading/preview/${response.id}`)
        } else throw new Error('internal_server_error')
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: i18n.t('internal_server_error'),
          visible: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
#activity {
  /* font-family: "Trebuchet MS", Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#activity td, #activity th {
  border: 1px solid #ddd;
  padding: 8px;
}

#activity tr:nth-child(even){background-color: #f2f2f2;}

#activity tr:hover {background-color: #ddd;}

#activity th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}
</style>
